var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ysf"},[_vm._v("\n  客服加载中...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }